<template>
  <v-container fluid class="px-3">
    <v-layout v-if="!loading" row wrap>
      <template v-if="!editing && parentField.canRead">
        <v-layout style="border-bottom: 1px solid gray; margin-bottom: 10px;">
          <v-flex xs10 class="text-left">
            <special-room-summary v-model="value" :link-options="linkOptions" />
          </v-flex>
          <v-flex xs2>
            <v-btn
              v-if="parentField.canEdit"
              @click="editing = !editing"
            >
              edit
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template v-else-if="parentField.canRead">
        <v-layout style="background: #eee;" row wrap>
          <v-flex xs12 class="text-right">
            <v-btn @click="editing = !editing">ok</v-btn>
          </v-flex>
          <v-flex
            v-for="(field, index) in fields"
            :key="index"
            pa-2
            v-bind="{[`xs${gridColumns(field)}`]: true}"
          >

            <!-- NUMBER -->

            <form-number
              v-if="field.info.type === 'Number' && parentField.canRead"
              v-model="value"
              :field="field"
              :module-name="moduleName"
            />

            <!-- FEATURES -->

            <features-from-group
              v-if="field.info.type === 'Features'  && parentField.canRead"
              v-model="value[field.fieldName]"
              :label="translation(field.fieldName)"
              :parent-module-name="moduleName"
              :feature-group-ids="featureGroupIds()"
            />

            <!-- LINK -->

            <v-select
              v-if="field.info.type === 'Link'  && parentField.canRead"
              v-model="value[field.fieldName]"
              :items="linkOptions && linkOptions[field.fieldName] || []"
              :label="translation(field.fieldName)"
              :disabled="!parentField.canEdit"
              item-text="text"
              item-value="value"
            ></v-select>

          </v-flex>
        </v-layout>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import FeaturesFromGroup from './FeaturesFromGroup'
import FormNumber from './FormElements/FormNumber'
import SpecialRoomSummary from './Special/SpecialRoomSummary'

export default {
  name: 'DenormalizedChild',

  components: {
    FeaturesFromGroup,
    FormNumber,
    SpecialRoomSummary
  },

  data () {
    return {
      editing: false,
      module: {},
      linkOptions: {},
      loading: true
    }
  },

  props: {
    field: {
      type: Object,
      default: () => {
        return {}
      }
    },

    parentField: {
      type: Object,
      default: () => {
        return {}
      }
    },

    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    modules () {
      return this.$store.getters.modules
    },

    language () {
      return this.$store.getters.language
    },

    fields () {
      let fields = []
      Object.keys(this.module.fields).forEach((fieldName) => {
        fields.push({
          fieldName: fieldName,
          info: this.module.fields[fieldName]
        })
      })
      return fields
    },

    linkItems () {
      return this.$store.getters['moduleListLinkItems'][this.moduleName]
    },

    moduleName () {
      return this.field.info.denormalizedModule
    }
  },

  created () {
    if (this.field.info && this.field.info.denormalizedModule) {
      this.module = this.modules[this.field.info.denormalizedModule]
    }
    this.$store.dispatch('getLinkFieldOptions', this.moduleName).then((result) => {
      this.updateLinkOptions()
      // change populated arrays as _id instaed, for dropdow
      Object.keys(this.module.fields).forEach((fieldName) => {
        if (this.module.fields[fieldName].type === 'Features' && !this.value[fieldName]) {
          // Don't need to do this as type not populated here
          // this.data[fieldName] = this.data[fieldName]._id
          this.value[fieldName] = {}
        }
      })
      if (!this.value.type) {
        this.editing = true
      }
      this.loading = false
    })
  },

  methods: {
    featureGroupIds () {
      let ids = []
      // check for type filed
      if (this.module && this.module.fields && this.module.fields.type) {
        if (this.module.fields.type.type === 'Link') {
          let typeFieldName = this.module.fields.type.linkModule

          // find selected type related feature group
          if (this.value.type && this.linkItems[typeFieldName]) {
            this.linkItems[typeFieldName].forEach((type) => {
              if (type.featureGroup && type._id === this.value.type) {
                ids.push(type.featureGroup._id)
              }
            })
          }
        }
      }
      return ids
    },

    gridColumns (field) {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12
      }
      if (field.info.gridSize) {
        return field.info.gridSize
      }
      return 12
    },

    translation (fieldName) {
      if (this.translations &&
        this.translations[this.language] &&
        this.translations[this.language][this.moduleName] &&
        this.translations[this.language][this.moduleName][fieldName]) {
        return this.translations[this.language][this.moduleName][fieldName]
      }
      return fieldName
    },

    updateLinkOptions () {
      Object.keys(this.module.fields).forEach((fieldName) => {
        let fieldInfo = this.module.fields[fieldName]
        if (['Link', 'MultiLink'].includes(fieldInfo.type)) {
          this.linkOptions[fieldName] = this.selectOptions(fieldName)
        }
      })
    },

    selectOptions (fieldName) {
      let linkModuleName = this.modules[this.moduleName].fields[fieldName].linkModule
      let linkModuleDisplayField = this.modules[this.moduleName].fields[fieldName].linkModuleDisplayField
      if (this.linkItems[linkModuleName]) {
        let multilingual = this.modules[linkModuleName].fields[linkModuleDisplayField].multilingual
        return this.linkItems[linkModuleName].map((option) => {
          return {
            text: multilingual
              ? option[linkModuleDisplayField + '_' + this.language] || option[linkModuleDisplayField + '_en']
              : option[linkModuleDisplayField],
            value: option._id
          }
        })
      }
      return []
    }
  }
}
</script>
